// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSButtonAnchor_button--default__NG6qg","icon-wrapper":"RSButtonAnchor_icon-wrapper__LVpTq","spin":"RSButtonAnchor_spin__adi81"};